<template>
    <div class="row mx-lg-auto">
        <div class="col-md-6 mx-lg-auto ">

            <template v-for="(answer, index) in answers" :key="index">
                <div class="card p-2 text-center card-transition bg-soft-primary-light" style="margin-top:15px; cursor: pointer;" v-if="answer.data == response" @click="SeleccionarRespuesta(answer)">
                    <div class="text-center">
                     <div class="card-body">
                        <p class="card-title"><strong>{{answer.title}}</strong></p>
                        <p class="card-text">{{answer.help}}</p>
                    </div>
                    </div>
                </div>

                <div class="card p-2 text-center card-transition card-selection" style="margin-top:15px; cursor: pointer;" @click="SeleccionarRespuesta(answer)" v-else>
                    <div class="text-center">
                     <div class="card-body">
                        <p class="card-title"><strong>{{answer.title}}</strong></p>
                        <p class="card-text">{{answer.help}}</p>
                    </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

export default {
  name: 'SelectOne',
  props: {

      response: {
            type: [Number, String]
      },
      answers: Array,
      FormularioTag: String,
      idQuestion: Number

  },

  methods: {

      SeleccionarRespuesta : function(answer){


        let respuesta = answer.data;

        let Mutation = {

            formulario: this.FormularioTag,
            question: this.idQuestion,
            response: respuesta,
            validate: true

        }

        window.scrollTo(0, 0);
            
        this.$store.commit('actualizarRespuestaFormulario', Mutation);




      }


  }
}
</script>